import apiBase from "../../../api/axios";

export const getActividadesAplicacionPlantelService = async (
  plantelId,
  page = 1,
  search = "",
  talento = "",
) => {
  let url = `v1/talentos-plantel/actividades-aplicacion/?page=${page}&plantel=${plantelId}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (talento) url += `&talento=${talento}`;
  const response = await apiBase.get(url);
  return response.data;
};

export const getActividadAplicacionPlantelByIdService = async (id) => {
  const response = await apiBase.get(
    `v1/talentos-plantel/actividades-aplicacion/${id}/`,
  );
  return response.data;
};

export const updateActividadAplicacionPlantelService = async (id, payload) => {
  const response = await apiBase.put(
    `v1/talentos-plantel/actividades-aplicacion/${id}/`,
    payload,
  );
  return response.data;
};

export const toggleActividadAplicacionPlantelActiveService = async (id) => {
  const response = await apiBase.post(
    `v1/talentos-plantel/actividades-aplicacion/${id}/toggle_active/`,
  );
  return response.data;
};

export const createMultiplesActividadesAplicacionPlantelService = async (
  payload,
) => {
  const response = await apiBase.post(
    `v1/talentos-plantel/actividades-aplicacion/crear-multiples/`,
    payload,
  );
  return response.data;
};
